(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
(function () {
  var link = document.querySelector('.collection-description__readmore');
  if (!link) return;
  link.addEventListener('click', function (e) {
    var target = document.getElementById('collection-description-full');
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('sticky-header') || document.querySelector('[data-sticky-header]') || document.querySelector('header');
    var offset = header ? header.offsetHeight : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 250;
    window.scrollTo({ top: top, behavior: 'smooth' });
    target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
